/**
 * Le Rêve Page Module
 * @module lerevePage
 * @description Contains page-specific functionality for lereve.html
 */

/**
 * Debug function to check CSS variables
 * @returns {void}
 */
function debugCSSVariables() {
     const root = document.documentElement;
     const accent1 = getComputedStyle(root).getPropertyValue('--color-accent');
     const accent2 = getComputedStyle(root).getPropertyValue('--color-secondary-accent');
     const accent3 = getComputedStyle(root).getPropertyValue('--color-tertiary-accent');
     const accent4 = getComputedStyle(root).getPropertyValue('--color-quaternary-accent');

     // console.log('🎨 CSS Variables Debug:');
     // console.log('--color-accent:', accent1);
     // console.log('--color-secondary-accent:', accent2);
     // console.log('--color-tertiary-accent:', accent3);
     // console.log('--color-quaternary-accent:', accent4);

     // Check data-theme attribute
     const theme = document.documentElement.getAttribute('data-theme');
     // console.log('📋 Current theme:', theme);
}

// Random images for The First The Last cards
function getThemeBasedFilters() {
     try {
          // Get current theme from DOM or localStorage
          const currentTheme = document.documentElement.getAttribute('data-theme') ||
               localStorage.getItem('theme') || 'light';

          if (currentTheme === 'nightmare') {
               // In nightmare theme: only use Nightmare_ images
               return { include: ['Nightmare_'], exclude: [] };
          } else {
               // In other themes: exclude Nightmare_ images
               return { include: [], exclude: ['Nightmare_'] };
          }
     } catch (e) {
          console.warn('Theme-based filtering error:', e);
          return { include: [], exclude: [] };
     }
}

function fileMatchesPrefixes(filename, include, exclude) {
     try {
          const lastDot = filename.lastIndexOf('.');
          const name = lastDot > 0 ? filename.slice(0, lastDot) : filename;
          if (include.length > 0 && !include.some(s => name.startsWith(s))) {
               return false;
          }
          if (exclude.length > 0 && exclude.some(s => name.startsWith(s))) {
               return false;
          }
          return true;
     } catch (_) {
          return true;
     }
}

function filterImagesByPrefixes(images, filters) {
     if (!filters || (!filters.include.length && !filters.exclude.length)) return images;
     const filtered = images.filter(img => fileMatchesPrefixes(img, filters.include, filters.exclude));
     return filtered.length ? filtered : images; // Fallback if filter yields none
}

async function randomizeTheFirstTheLastImages() {
     try {
          // Load images from both folders
          const [onSePrepareResponse, dansLaRueResponse] = await Promise.all([
               fetch('/assets/img/SDGDR/on_se_prepare_pour_la_rue.json'),
               fetch('/assets/img/SDGDR/dans_la_rue.json')
          ]);

          const onSePrepareData = await onSePrepareResponse.json();
          const dansLaRueData = await dansLaRueResponse.json();

          // Apply theme-based filtering
          const filters = getThemeBasedFilters();
          const onSePrepareImages = filterImagesByPrefixes(onSePrepareData.images, filters);
          const dansLaRueImages = filterImagesByPrefixes(dansLaRueData.images, filters);

          // Select 2 images from "on se prepare pour la rue" and 4 from "dans la rue"
          const onSePrepareShuffled = [...onSePrepareImages].sort(() => 0.5 - Math.random());
          const dansLaRueShuffled = [...dansLaRueImages].sort(() => 0.5 - Math.random());

          const onSePrepareSelected = onSePrepareShuffled.slice(0, 2); // First 2 from "on se prepare"
          const dansLaRueSelected = dansLaRueShuffled.slice(0, 4); // Next 4 from "dans la rue"

          // Update all 6 card images - assign specific images to specific cards
          const cardImgs = document.querySelectorAll('.thefirstthelast-card-img img');

          // First 2 cards: "On se prepare pour la rue" folder
          for (let i = 0; i < 2 && i < onSePrepareSelected.length; i++) {
               if (cardImgs[i]) {
                    const imageData = onSePrepareSelected[i];
                    // Use the original PNG path from the image data object
                    const imagePath = `/assets/img/SDGDR/On se prepare pour la rue/${imageData.filename}`;
                    cardImgs[i].src = imagePath;
                    console.log(`🎴 Card ${i}: ${imagePath}`);
               }
          }

          // Next 4 cards: "Dans la Rue" folder
          for (let i = 0; i < 4 && i < dansLaRueSelected.length; i++) {
               if (cardImgs[i + 2]) {
                    const imageData = dansLaRueSelected[i];
                    // Use the original PNG path from the image data object
                    const imagePath = `/assets/img/SDGDR/Dans la Rue/${imageData.filename}`;
                    cardImgs[i + 2].src = imagePath;
                    console.log(`🎴 Card ${i + 2}: ${imagePath}`);
               }
          }

          // console.log('🎴 The First The Last cards images loaded');
     } catch (error) {
          console.warn('Could not load The First The Last images:', error);
     }
}

/**
 * Initialize the Le Rêve page functionality
 * @returns {Function} Cleanup function to remove event listeners
 */
function initLeRevePage() {
    randomizeTheFirstTheLastImages();
    setTimeout(debugCSSVariables, 1000);
    
    // Return cleanup function
    return function cleanup() {
        // Add any cleanup logic here if needed
    };
}

// Auto-initialize if loaded directly in browser with type="module"
let cleanupLeRevePage;

function init() {
    cleanupLeRevePage = initLeRevePage();
}

// Initialize on DOMContentLoaded
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}

// Export public API
export { 
    debugCSSVariables, 
    randomizeTheFirstTheLastImages, 
    initLeRevePage as init, 
    cleanupLeRevePage as cleanup 
};

export default {
    debug: debugCSSVariables,
    randomizeImages: randomizeTheFirstTheLastImages,
    init: initLeRevePage,
    cleanup: cleanupLeRevePage
};

// Make debug function available globally
window.debugCSSVariables = debugCSSVariables;
